<template>
	<div class="recht-block recht-columns-content-block" :class="styleClass">
		<div class="recht-block-base" :class="rootClasses">
			<div class="container">
                <div :class="rowClasses">
					<div v-if="data.columnImage && data.columnImage.length" class="col-lg-6 col-md-5 col-sm-12 recht-col-center-content-vertically">
						<img class="recht-image" loading="lazy" :src="data.columnImage" />
					</div>
					<div :class="textColClasses">
						<h2 v-if="data.title && data.title.length" :class="`recht-title recht-text-${data.textAlignment}`">
							{{ data.title }}
						</h2>
						<div v-if="data.text" :class="`recht-richtext recht-text-${data.textAlignment}`" v-html="data.text"></div>
						<Buttons
							v-if="data.buttons && (data.buttons.length || typeof data.buttons == 'object' && Object.keys(data.buttons).length)"
							:buttons="data.buttons"
							:alignment="data.textAlignment"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ColumnsContent',
		props: {
			data: {
				type: Object,
				default: () => {
					return {}
				},
			}
		},
		components: {
			Buttons: () => import('@/blocks_components/Buttons.vue')
		},
		computed: {
			styleClass() {
				return {}
			},
			rootClasses() {
				return {}
			},
			rowClasses() {
				return {
					['row']: true,
					['recht-row']: true,
					['recht-flex-flip']: this.data?.flipColumns ? true : false
				}
			},
			textColClasses() {
				if (this.data.columnImage?.length) return {
					['recht-col']: true,
					['recht-fields-margin']: true,
					['col-lg-6']: true,
					['col-md-7']: true,
					['col-sm-12']: true,
					['recht-col-center-content-vertically']: true
				};

				return { ['col-12']: true, ['recht-col-center-content-vertically']: true };
			}
		},
		beforeMount() {
			console.log('ColumnsContent received data', this.data);
		}
	}
</script>

<style lang="scss" scoped>
	.recht-columns-content-block {
		::v-deep {
			.recht-buttons {
				margin-top: -1rem !important;
			}
		}
	}
</style>
